<template>
  <div class="contract-information-page pb60" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="付款通知单审批申请"></Title>
    <div class="contract-base-box">
      <p class="contract-base-name">付款通知书信息</p>
      <div class="contract-apply-box mb0">
        <div class="contract-apply-item"><span>企业名称：</span>{{ pageData && pageData.tenantName }}</div>
        <div v-if="pageData && pageData.organisationName" class="contract-apply-item"><span>组织名称：</span>{{ pageData && pageData.organisationName }}</div>
        <div class="contract-apply-item">
          <span>关联运营报告流程：</span
          ><span class="fontC-4fa1a4 c-pointer" @click="operationDialogVisible = true">查看</span>
        </div>
      </div>
      <!-- 附件查看 -->
      <div class="contract-base-box" v-show="showFile">
        <div class="contract-apply-file mb0">
          <span>运营报告：</span>
          <div>
            <div v-for="(item, index) in fileList" :key="index">
              <div class="contract-file-inform">
                <span> {{ item.name }}</span
                ><span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-row :gutter="24" class="input-box">
        <el-col :span="20" v-show="!showFile">
          <div class="contract-base-title"><span class="fontC-red">*</span>运营报告：</div>
          <div>
            <el-upload
              class="upload-demo t-left"
              action="#"
              multiple
              :limit="1"
              accept=".pdf,.PDF,.docx,.doc"
              :on-exceed="handleExceed"
              :on-remove="handleFileRemove"
              :http-request="uploadFile"
              :file-list="fileList"
              :beforeUpload="beforeAvatarUpload"
            >
              <div class="import-btn-tips">
                <el-button size="mini" icon="el-icon-my-import" style=" margin-bottom: 0" type="importNew"
                  >导入文件</el-button
                >
                <div class="import-step-tip">支持.pdf、.PDF、.docx、.doc文件，单个文件不得大于{{ fileSizeTip }}M</div>
                <!-- <div slot="tip" class="el-upload__tip">支持.pdf、.docx、.doc文件，单个文件不得大于{{ fileSizeTip }}M</div> -->
              </div>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="10" >
          <div class="contract-base-title"><span class="fontC-red">*</span>申请盖章：</div>
          <el-select v-model="formData.isApplyStamp" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10" v-if="formData.isApplyStamp=='Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>印章类型：</div>
          <el-select v-model="formData.stampType" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in getCodeListByKey('印章类型')" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否需要推广计划盖章：</div>
          <el-select v-model="formData.isShowPromotionPlan" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10" >
          <div class="contract-base-title"><span class="fontC-red">*</span>是否邮寄：</div>
          <el-select v-model="formData.isMail" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否需要验收单盖章：</div>
          <el-select v-model="formData.isDisplayReceipt" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="20"  v-if="formData.isMail=='Y'">
          <div class="contract-base-title"><span class="fontC-red"> </span>邮寄地址：</div>
          <el-input
            style="max-width: calc(50% + 324px);"
            v-model.trim="formData.mailAddress"
            placeholder="请输入"
            clearable
            maxlength="50"
            type="textarea"
            resize="none"
            :rows="2"
          ></el-input>
        </el-col>

        <el-col :span="20">
          <div class="contract-base-title mt15"><span class="fontC-red"> </span>附件上传：</div>
          <div>
            <el-upload
              class="upload-demo t-left mt15"
              action="#"
              multiple
              accept=".pdf,.PDF,.docx,.doc,.jpg,.jpeg,.png,.xls,.xlsx"
              :on-exceed="handleExceedOther"
              :on-remove="handleFileRemoveOther"
              :http-request="uploadFileOther"
              :file-list="fileListOther"
              :beforeUpload="beforeAvatarUploadOther"
            >
              <div class="import-btn-tips">
                <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                  >导入文件</el-button
                >
                <div class="import-step-tip">支持.pdf,.PDF,.docx,.doc,.jpg,.jpeg,.png,.xls,.xlsx,.ofd文件，单个文件不得大于{{ fileSizeTip }}M</div>
                <!-- <div slot="tip" class="el-upload__tip">
                  .pdf,.PDF,.docx,.doc,.jpg,.jpeg,.png,.xls,.xlsx文件，单个文件不得大于{{ fileSizeTip }}M
                </div> -->
              </div>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="contract-base-title"><span class="fontC-red"> </span>备注说明：</div>
          <el-input
            style="max-width: calc(50% + 324px);"
            v-model.trim="formData.remarks"
            placeholder="请输入"
            clearable
            maxlength="100"
            type="textarea"
            resize="none"
            :rows="2"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <!-- 需开票的信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开票/收款信息</p>
      <el-row :gutter="24">
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否已开票：</div>
          <el-select
            @change="isInvoicedChange"
            v-model="formData.isInvoiced"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否回款：</div>
          <el-select
            @change="isReceivePaymentChange"
            v-model="invoiceApplyDTO.isReceivePayment"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10" v-show="formData.isInvoiced == 'Y'&&invoiceApplyDTO.isReceivePayment != 'Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>
            <!-- 预开票流程： -->
            <el-select
            @change="isDataSourceChange"
            v-model="formData.invoiceDataSource"
            class="contract-base-content-left"
            placeholder="请选择"
          >
            <el-option v-for="item in dataSourceOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
          </div>
          <!-- 预开票流程： -->
          <el-select
            v-show="formData.invoiceDataSource == '1'"
            filterable
            multiple
            v-model="formData.planInvoiceApplyGuidList"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option
              v-for="item in advanceInvoicingTableData"
              :key="item.guid"
              :label="item.label"
              :value="item.guid"
            >
            </el-option>
          </el-select> 
          
          <!-- 上游信息发票流程： -->
          <el-select
            v-show="formData.invoiceDataSource == '2'"
            filterable
            multiple
            v-model="formData.invoiceGuids"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option
              v-for="item in invoiceGuidTableData"
              :key="item.guid"
              :label="item.label"
              :value="item.guid"
            >
            </el-option>
          </el-select>
          
        </el-col>
        <el-col style="align-items: center;" :span="10" v-if="formData.isInvoiced == 'Y'&&invoiceApplyDTO.isReceivePayment != 'Y'&&formData.invoiceDataSource == '1'">
          <div class="contract-base-title"><span class="fontC-red"></span>小计：</div>
          <span>{{ getSumAmount(formData.planInvoiceApplyGuidList,6)| numDigit }} 元</span>
        </el-col>
        <el-col :span="10" v-show="formData.isInvoiced == 'N'">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否开票：</div>
          <el-select
            v-model="formData.isApplyInvoice"
            class="contract-base-content"
            placeholder="请选择"
            @change="isApplyInvoiceChange"
          >
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        
        <el-col :span="10" v-if="formData.isInvoiced != 'Y'&&invoiceApplyDTO.isReceivePayment == 'Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>关联上游收款：</div>
          <el-select
            multiple
            filterable
            v-model="invoiceApplyDTO.receivePaymentGuidList"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in isApplyInvoiceTableData" :key="item.guid" :label="item.label" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col style="align-items: center;" :span="10" v-if="formData.isInvoiced != 'Y'&&invoiceApplyDTO.isReceivePayment == 'Y'"></el-col>
        <el-col style="align-items: center;" :span="10" v-if="formData.isInvoiced != 'Y'&&invoiceApplyDTO.isReceivePayment == 'Y'">
          <div class="contract-base-title"><span class="fontC-red"></span>小计：</div>
          <span>{{ getSumAmount(invoiceApplyDTO.receivePaymentGuidList,5)| numDigit }} 元</span>
        </el-col>
      </el-row>
      <div 
        v-if="formData.isInvoiced == 'Y'&&invoiceApplyDTO.isReceivePayment == 'Y'">
        <div v-for="(item, index) in planInvoiceReceivePaymentList" :key="index">
          <el-row :gutter="24" >
            <el-col :span="10" >
              <div class="contract-base-title"><span class="fontC-red">*</span>
                <!-- 预开票流程： -->
                <el-select
                @change="isDataSourceChange($event,item)"
                v-model="item.invoiceDataSource"
                class="contract-base-content-left"
                placeholder="请选择"
              >
                <el-option v-for="item in dataSourceOption" :key="item.value" :label="item.text" :value="item.value">
                </el-option>
              </el-select>
              </div>
              <!-- 预开票流程： -->
              <el-select
               v-show="item.invoiceDataSource == '1'"
                filterable
                multiple
                :multiple-limit="item.receivePaymentList.length>1?1:0"
                @change="$forceUpdate()"
                v-model="item.planInvoiceApplyList"
                class="contract-base-content"
                placeholder="请选择"
              >
              <!-- :multiple-limit="item.receivePaymentList.length>1?1:0" -->
                <el-option
                  v-for="item in advanceInvoicingTableData"
                  :key="item.guid"
                  :label="item.label"
                  :value="item.guid"
                >
                </el-option>
              </el-select>
              <!-- 上游信息发票流程： -->
              <el-select
               v-show="item.invoiceDataSource == '2'"
                filterable
                multiple
                @change="$forceUpdate()"
                v-model="item.invoiceGuids"
                class="contract-base-content"
                placeholder="请选择"
              >
              <!-- :multiple-limit="item.receivePaymentList.length>1?1:0" -->
                <el-option
                  v-for="item in invoiceGuidTableData"
                  :key="item.guid"
                  :label="item.label"
                  :value="item.guid"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="10">
              <div class="contract-base-title"><span class="fontC-red">*</span>关联上游收款：</div>
              <el-select
                multiple
                :multiple-limit="(item.invoiceDataSource == '1'&&item.planInvoiceApplyList.length>1)||(item.invoiceDataSource == '2'&&item.invoiceGuids.length>0)?1:0"
                filterable
                @change="$forceUpdate()"
                v-model="item.receivePaymentList"
                class="contract-base-content"
                placeholder="请选择"
              >
              <!-- :multiple-limit="item.planInvoiceApplyList.length>1?1:0" -->
                <el-option v-for="item in isApplyInvoiceTableData" :key="item.guid" :label="item.label" :value="item.guid">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <!-- <span>添加</span> -->
              <!-- v-show="index === 0" -->
              <el-button class="add-button" v-show="index === 0" type="defalut" size="mini"  @click="addItem">新增</el-button>
              <el-button type="danger" v-show="planInvoiceReceivePaymentList.length>1" size="mini" @click="delItem(item,index)">删除</el-button>
              <!--  v-show="formData.planInvoiceReceivePaymentList.length>1" -->
            </el-col>
            
          </el-row>
          <el-row :gutter="24" class="sum-row">
            <el-col :span="10" >
              <div class="contract-base-title"><span class="fontC-red"></span>小计：</div>
              <span v-show="item.invoiceDataSource == '1'">{{ getSumAmount(item.planInvoiceApplyList,1)| numDigit }} 元</span>
              <span v-show="item.invoiceDataSource == '2'">{{ getSumAmount(item.invoiceGuids,7)| numDigit }} 元</span>
            </el-col>
            <el-col :span="10">
              <div class="contract-base-title"><span class="fontC-red"></span>小计：</div>
              <span>{{ getSumAmount(item.receivePaymentList,2)| numDigit }} 元</span>
            </el-col>
          </el-row>
        </div >
        <el-row :gutter="24" class="sum-row">
          <el-col :span="10" >
            <div class="contract-base-title"><span class="fontC-red"></span>合计：</div>
            <span style="color: rgb(255, 95, 31);">{{ getSumAmount(planInvoiceReceivePaymentList,3)| numDigit }}</span>&nbsp;元
          </el-col>
          <el-col :span="10">
            <div class="contract-base-title"><span class="fontC-red"></span>合计：</div>
            <span style="color: rgb(255, 95, 31);">{{ getSumAmount(planInvoiceReceivePaymentList,4)| numDigit }}</span>&nbsp;元
          </el-col>
        </el-row>
      </div>
      
    </div>
    <!-- 开票说明 -->
    <div class="contract-base-box" v-show="formData.isApplyInvoice == 'Y'">
      <p class="contract-base-name">开票说明</p>
      <el-row :gutter="24">
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票金额（元）：</div>
          <el-input
            disabled
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            v-model.trim="invoiceApplyDTO.invoiceAmount"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票主体：</div>
          <el-select
            disabled
            filterable
            v-model="invoiceApplyDTO.servicerTenantGuid"
            @change="servicerTenantChange"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票日期：</div>
          <el-date-picker
            class="contract-base-content"
            v-model="invoiceApplyDTO.invoiceDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票类型：</div>
          <el-select v-model="invoiceApplyDTO.invoiceOptions" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('发票选项')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>药企名称：</div>
          <el-select
            filterable
            v-model="invoiceApplyDTO.tenantGuid"
            @change="tenantChange"
            class="contract-base-content"
            placeholder="请选择"
            @focus="tenantFocus(1)"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>组织名称：</div>
          <el-select
            filterable
            v-model="invoiceApplyDTO.organisationGuid"
            @change="organisationChange"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in organisationList" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>

        <!-- <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票类目：</div>
          <el-select v-model="invoiceApplyDTO.invoiceCategory" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('发票类目')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>预计回款日期：</div>
          <el-date-picker
            class="contract-base-content"
            v-model="invoiceApplyDTO.planRepayDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-col>
        <!-- <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否回款：</div>
          <el-select
            @change="invoiceApplyDTO.receivePaymentGuidList = []"
            v-model="invoiceApplyDTO.isReceivePayment"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12" v-if="invoiceApplyDTO.isReceivePayment == 'Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>关联上游收款：</div>
          <el-select
            multiple
            filterable
            v-model="invoiceApplyDTO.receivePaymentGuidList"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in isApplyInvoiceTableData" :key="item.guid" :label="item.label" :value="item.guid">
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="20">
          <div class="contract-base-title"><span class="fontC-red"> </span>简述或备注：</div>
          <el-input
            style="max-width: calc(50% + 324px);"
            v-model.trim="invoiceApplyDTO.remarks"
            placeholder="请输入"
            clearable
            maxlength="100"
            :rows="3"
            type="textarea"
            resize="none"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <!-- 开票信息 -->
    <div class="contract-base-box" v-show="formData.isApplyInvoice == 'Y'">
      <p class="contract-base-name">开票信息</p>
      <el-row :gutter="24" class="mb20">
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票抬头：</div>
          <el-input
            disabled
            v-model.trim="invoiceApplyDTO.invoiceTenantName"
            class="contract-base-content"
            :maxlength="30"
            placeholder="不可修改，来自开户银行选择"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>合计金额(元)：</div>
          <el-input
            disabled
            v-model.trim="invoiceApplyDTO.invoiceAmount"
            class="contract-base-content"
            :maxlength="30"
            placeholder="不可修改，请选择开户银行"
            clearable
          ></el-input>
        </el-col>
         <!-- 发票类目 start -->
        <div class="invoice-category" v-for="(item, index) in invoiceApplyDTO.invoiceApplyDetailList" :key="index">
          <el-col :span="10">
            <div class="contract-base-title"><span class="fontC-red">*</span>发票类目{{index+1}}：</div>
            <el-select v-model="item.invoiceCategory" class="contract-base-content" placeholder="请选择">
              <el-option
                v-for="item in getCodeListByKey('发票类目')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10">
            <div class="contract-base-title"><span class="fontC-red">*</span>金额(元)：</div>
            <el-input
              v-model.trim="item.invoiceAmount"
              class="contract-base-content"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              maxlength="12"
              placeholder="请输入"
              clearable
            ></el-input>
            <div class="invoice-category-btns">
              <div class="add"  @click="addInvoiceCategory">添加类目</div>
              <div class="del" v-if="index!=0" @click="delInvoiceCategory(index)">删除</div>
            </div>
          </el-col>
        </div>
        <!-- 发票类目 end -->

        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red">*</span>开户银行：</div>
          <el-select
            filterable
            v-model="invoiceApplyDTO.contractBankGuid"
            @change="bankChange"
            class="contract-base-content"
            placeholder="请选择"
            @focus="tenantFocus(2)"
            clearable
          >
          <el-option v-for="item in bankList" :key="item.guid" :label="item.bankName" :value="item.guid"> 
              <span style="float: left">{{ `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType,'账户类型')}` }}</span>
          </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red"> </span>税号：</div>
          <el-input
            disabled
            v-model.trim="invoiceApplyDTO.taxpayerId"
            class="contract-base-content"
            oninput="if(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/.test(value)) value=value.replace(/\D/g,'')"
            :maxlength="20"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red"> </span>银行账号：</div>
          <el-input
            disabled
            v-model.trim="invoiceApplyDTO.bankAccount"
            class="contract-base-content"
            :maxlength="15"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red"> </span>电话号码：</div>
          <el-input
            v-model.trim="invoiceApplyDTO.contactTel"
            @input="form.contactsMobile = form.contactsMobile.replace(/[^\d\-\d]/g, '')"
            class="contract-base-content"
            :maxlength="20"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>

        <el-col :span="10">
          <div class="contract-base-title"><span class="fontC-red"> </span>单位地址：</div>
          <el-input
            v-model.trim="invoiceApplyDTO.address"
            class="contract-base-content"
            :maxlength="50"
            placeholder="请输入"
            clearable
            type="textarea"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <!-- 付款通知书 -->
    <div class="contract-base-box">
      <div style="max-width:700px">
        <p class="contract-base-name">
          <span>{{ getTitleType(formData.tenantGuid) }}</span>
          <!-- <el-button type="borderGreen" size="mini" @click="showPrint = true">打印</el-button> -->
        </p>
        <div class="pay-box">
          <h2>{{ getTitleType(pageData.tenantGuid) }}<div style="font-size:12px;font-weight: normal;">（账单周期：{{pageData.accountMonthStartDate}}至{{pageData.accountMonthEndDate}})</div></h2>
          <p>致{{pageData.tenantName}}：</p>
          <p>根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下费用明细，并进行相关款项支付，谢谢。</p>
          <table border="1px" class="mb30 w100f">
            <tr>
              <td colspan="2" class="tBg tdCenter font-S18">本期应付款汇总结算明细</td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期应付款合计金额（小写）：</td>
              <td class="t-right">{{ pageData && pageData.currentPayAmount | numDigit | numFmt }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期应付款合计（大写）：</td>
              <td class="t-right">{{ pageData && pageData.currentPayAmount | smallToBig }}</td>
            </tr>
          </table>
          <div class="back-color-fff content-main-box h100f">
            <el-table :data="tableData" stripe border style="width: 100%" max-height="50vh">
              <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="tenantName"
                label="任务类型"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="160"
                fixed="left"
              >
                <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="数量"
                show-overflow-tooltip
                header-align="center"
                align="right"
                min-width="120"
              >
                <template slot-scope="scope">{{ scope.row.taskTotal }}</template>
              </el-table-column>
              <el-table-column
                prop="planYear"
                label="单价"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="130"
              >
              <template slot-scope="scope">{{ (scope.row.settlePercent ? '-' : scope.row.taskPrice) | numFmt | numDigit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="计价单位"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="80"
              >
              <template slot-scope="scope">{{ scope.row.settlePercent ? '-' : scope.row.taskPriceUnit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="金额(元)"
                show-overflow-tooltip
                header-align="center"
                align="right"
                min-width="140"
              >
                <template slot-scope="scope">{{ scope.row.taskAmount | numFmt | numDigit }}</template>
              </el-table-column>
              <!-- <el-table-column
              prop="planName"
              label="备注"
              show-overflow-tooltip
              header-align="center"
              align="left"
              min-width="140"
            >
              <template slot-scope="scope">{{ scope.row.planName || '-' }}</template>
            </el-table-column> -->
            </el-table>
          </div>
          <table border="1px" class="mb15 w100f">
            <tr>
              <td class="tdBg" width="212">合计任务金额(元)</td>
              <td class="t-right">{{ pageData && pageData.taskSumAmount | numFmt | numDigit }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="212">工业考核得分</td>
              <td class="t-right">{{ comprehensiveGradeComputed }}</td>
            </tr>
            <tr v-show="pageData && pageData.isContainServiceFee !== 'Y'">
              <td class="tdBg" width="212">平台运营服务费(元)</td>
              <td class="t-right">{{ pageData && pageData.serviceFee | numFmt | numDigit }}</td>
            </tr>
            <tr v-show="pageData && pageData.reportCoefficient != null&&pageData.isContainServiceFee!=='Y'">
              <td class="tdBg" width="212">数据服务费(元)</td>
              <td class="t-right">{{ pageData && pageData.dataServiceFee | numFmt | numDigit }}</td>
            </tr>        
            <tr>
              <td class="tdBg" width="212">本期应付金额(元)</td>
              <td class="t-right">{{ pageData && pageData.currentPayAmount | numFmt | numDigit }}</td>
            </tr>
          </table>
          <!-- <div class="total-money-box">
            <div class="total-money-list">
              <span class="total-money-title">合计任务金额</span
              ><span class="total-money-num">{{ pageData && pageData.taskSumAmount | numFmt | numDigit }}</span
              >元
            </div>
            <div class="total-money-list">
              <span class="total-money-title">工业考核得分</span
              ><span class="total-money-num">{{ pageData && (pageData.comprehensiveGrade * 100).toFixed(2) }}</span>
            </div>
            <div class="total-money-list" v-show="pageData && pageData.isContainServiceFee !== 'Y'">
              <span class="total-money-title">平台运营服务费({{ pageData && pageData.serviceFeeRate }}%)</span
              ><span class="total-money-num">{{ pageData && pageData.serviceFee | numFmt | numDigit }}元</span>
            </div>
            <div class="total-money-list">
              <span class="total-money-title">本期应付金额</span
              ><span class="total-money-num">{{ pageData && pageData.currentPayAmount | numFmt | numDigit }}</span
              >元
            </div>
          </div> -->
          <p class="pay-title-txt mb15">支付账户信息如下：</p>
          <table border="1px" class="mb15 w100f">
            <tr>
              <td class="tdBg" width="170">开户名称：</td>
              <td class="t-left">{{ pageData && pageData.serviceTenantName }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="170">开户银行：</td>
              <td class="t-left">
                <el-select
                  filterable
                  v-model="formData.tenantBankGuid"
                  @change="tenantBankChange"
                  class="contract-base-content"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in currentTenantBankList"
                    :key="item.guid"
                    :value="item.guid"
                    :label="item.bankName"
                  >
                  <span style="float: left">{{ `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType,'账户类型')}` }}</span>
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="tdBg" width="170">银行账号：</td>
              <td class="t-left">{{ formData && formData.bankAccount }}</td>
            </tr>
          </table>
          <div class="page-write">
            <div>申请单位（盖章）：</div>
            <div>审核单位（盖章）：</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 推广计划确认单 -->
    <div class="contract-base-box" v-show="formData.isShowPromotionPlan=='Y'">
      <div v-if="promotionType==1" style="max-width: 700px">
        <p class="contract-base-name">
          <span>{{ promotionTitle }}</span>
          <!-- <el-button type="borderGreen" size="mini" @click="showPlanPrint = true">打印</el-button> -->
        </p>
        <div class="pay-box">
          <h2>{{ promotionTitle }}<div style="font-size:12px;font-weight: normal;">(执行日期：{{pageData.accountMonthStartDate}}至{{pageData.accountMonthEndDate}})</div></h2>
          <p>致{{pageData.tenantName}}：</p>
          <p>根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下推广计划，谢谢。</p>
          <div style="display: flex;justify-content: space-between">
            <p>委托方：{{pageData.tenantName}}</p>
            <p>服务方：{{pageData.serviceTenantName}}</p>
          </div>
          <div style="display: flex;justify-content: flex-start">
            <div >任务标题：</div>
            <div>
              <!-- taskTitleName -->
              <div style="margin-bottom:10px;text-align: left;" v-for="item in pageData.taskInfoList">
                {{ item.name || '-' }}
                <span class="fontC-4fa1a4 c-pointer ml10" @click="seeDetail(item)">查看详情</span>
              </div>
            </div>
          </div>
          
          <div class="back-color-fff content-main-box h100f" >
            <el-table :data="planData" stripe border style="width: 100%;margin-bottom: 20px;" max-height="50vh">
              <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taskContentName"
                label="任务类型"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="100"
                fixed="left"
              >
                <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="数量"
                show-overflow-tooltip
                header-align="center"
                align="right"
                min-width="100"
              >
              <template slot-scope="scope">
                <div v-if="scope.row.taskTotalType!='固定量人均'&&scope.row.taskTotalType!='不限量'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ scope.row.taskTotal }}</div>
                  <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                </div>
                <div v-if="scope.row.taskTotalType=='固定量人均'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ scope.row.taskAvg }}</div>
                  <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                </div>
                <div v-if="scope.row.taskTotalType=='不限量'" style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>不限量</div>
                </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="planYear"
                label="价格"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="100"
              >
              <template slot-scope="scope">{{ scope.row.tenantTaskPrice }} {{ scope.row.tenantTaskPriceUnit }}</template>
                  <!-- <template slot-scope="scope">{{ (scope.row.settlePercent ? '-' : scope.row.taskPrice) | numFmt | numDigit }}</template> -->
              </el-table-column>
              <el-table-column
                prop="tenantTaskNote"
                label="任务描述"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="170"
              >
              <template slot-scope="scope">{{ getTenantTaskNote(scope.row) }}</template>
              </el-table-column>
              
              
            </el-table>
          </div>
          <div class="page-write">
            <div>申请单位（盖章）：</div>
            <div>审核单位（盖章）：</div>
          </div>
          <!-- <p class="pay-title-txt" style="justify-content: flex-end; padding-right: 100px">
            <span>盖章处</span>
          </p> -->
        </div>
      </div>
      <div v-if="promotionType==2" style="max-width: 700px">
        <p class="contract-base-name">
          <span>{{ promotionTitle }}</span>
        </p>
        <div class="pay-box">
          <h2>{{ promotionTitle }}<div style="font-size:12px;font-weight: normal;">（账单周期：{{pageData.accountMonthStartDate}}至{{pageData.accountMonthEndDate}})</div></h2>
          <p>致{{pageData.tenantName}}：</p>
          <p>根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下预算费用明细，谢谢。</p>
          <table border="1px" class="mb30 w100f">
            <tr>
              <td colspan="2" class="tBg tdCenter font-S18">本期预付款汇总结算明细</td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期预付款合计金额（小写）：</td>
              <td class="t-right">{{ getSumAmount(planData,8) | numDigit | numFmt }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期预付款合计（大写）：</td>
              <td class="t-right">{{ getSumAmount(planData,8) | smallToBig }}</td>
            </tr>
          </table>
          <div class="back-color-fff content-main-box h100f">
            <el-table :data="planData" stripe border style="width: 100%" max-height="50vh">
              <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taskContentName"
                label="任务类型"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="160"
                fixed="left"
              >
                <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="数量"
                show-overflow-tooltip
                header-align="center"
                align="right"
                min-width="120"
              >
              <template slot-scope="scope">
                <div v-if="scope.row.taskTotalType!='不限量'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ scope.row.taskTotal }}</div>
                  <!-- <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span> -->
                </div>
                <!-- <div v-if="scope.row.taskTotalType=='固定量人均'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ scope.row.taskAvg }}</div>
                  <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                </div> -->
                <div v-if="scope.row.taskTotalType=='不限量'" style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>不限量</div>
                </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="planYear"
                label="单价"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="130"
              >
                <template slot-scope="scope">{{ scope.row.tenantTaskPrice | numFmt | numDigit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="计价单位"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="80"
              >
              <template slot-scope="scope">{{ scope.row.tenantTaskPriceUnit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="金额(元)"
                show-overflow-tooltip
                header-align="center"
                align="right"
                min-width="140"
              >
                <template slot-scope="scope">{{ scope.row.taskAmount | numFmt | numDigit }}</template>
              </el-table-column>
            </el-table>
          </div>
          <table border="1px" class="mb15 w100f">
            <tr>
              <td class="tdBg" width="212">合计任务金额(元)</td>
              <td class="t-right">{{ getSumAmount(planData,8) | numFmt | numDigit }}</td>
            </tr>
          </table>
          <!-- <div class="total-money-box">
            <div class="total-money-list">
              <span class="total-money-title">合计任务金额</span
              ><span class="total-money-num">{{ pageData && pageData.taskSumAmount | numFmt | numDigit }}</span
              >元
            </div>
            <div class="total-money-list">
              <span class="total-money-title">工业考核得分</span
              ><span class="total-money-num">{{ pageData && (pageData.comprehensiveGrade * 100).toFixed(2) }}</span>
            </div>
            <div class="total-money-list" v-show="pageData && pageData.isContainServiceFee !== 'Y'">
              <span class="total-money-title">平台运营服务费({{ pageData && pageData.serviceFeeRate }}%)</span
              ><span class="total-money-num">{{ pageData && pageData.serviceFee | numFmt | numDigit }}元</span>
            </div>
            <div class="total-money-list">
              <span class="total-money-title">本期应付金额</span
              ><span class="total-money-num">{{ pageData && pageData.currentPayAmount | numFmt | numDigit }}</span
              >元
            </div>
          </div> -->
          <p class="pay-title-txt mb15">支付账户信息如下：</p>
          <table border="1px" class="mb15 w100f">
            <tr>
              <td class="tdBg" width="170">开户名称：</td>
              <td class="t-left">{{ pageData && pageData.serviceTenantName }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="170">开户银行：</td>
              <td class="t-left">
                <el-select
                  filterable
                  disabled
                  v-model="formData.tenantBankGuid"
                  @change="tenantBankChange"
                  class="contract-base-content"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in currentTenantBankList"
                    :key="item.guid"
                    :value="item.guid"
                    :label="item.bankName"
                  >
                  <span style="float: left">{{ `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType,'账户类型')}` }}</span>
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="tdBg" width="170">银行账号：</td>
              <td class="t-left">{{ formData && formData.bankAccount }}</td>
            </tr>
          </table>
          <div class="page-write">
            <div>申请单位（盖章）：</div>
            <div>审核单位（盖章）：</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 推广服务验收单区域 -->
    <div class="contract-base-box" v-show="formData.isDisplayReceipt=='Y'">
      <ExcelFile :data="pageData" :tableData="planData"/>
    </div>
    <!-- 验收单 -->
    <el-dialog title="查看关联的运营报告流程" :visible.sync="operationDialogVisible" :modal-append-to-body="false" width="900px" top="15%">
      <div class="back-color-fff content-main-box h00f">
        <el-table :data="operationTableData" stripe border style="width: 100%" height="60vh">
          <el-table-column label="序号" width="50" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="flowName"
            label="流程名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.flowName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="发起人"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="90"
          >
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizTenantName"
            label="药企名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="160"
          >
            <template slot-scope="scope">{{ scope.row.bizTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizOrganisationName"
            label="组织名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.bizOrganisationName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="taskTitleName"
            label="任务包名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.taskTitleName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="accountMonthName"
            label="核算月"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="90"
          >
            <template slot-scope="scope">{{ scope.row.accountMonthName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="currentPayAmount"
            label="应付金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="140"
          >
            <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="comprehensiveGrade"
            label="分值"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="70"
          >
            <template slot-scope="scope">{{ getComprehensiveGrade(scope.row) }}</template>
          </el-table-column>
          <el-table-column  width="100" label="操作" fixed="right" header-align="center" align="center">
            <template slot-scope="scope"><span class="txt-color" @click="toOperationDetail(scope.row)">详情</span></template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <printDialogCheck
      v-if="showPrint"
      :showPrintDialog.sync="showPrint"
      :printData="pageData"
      @closePrint="showPrint = false"
      :printType="2"
      :currentTenantName="currentTenantName"
    ></printDialogCheck>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderGreen" size="small" @click="saveReq(0)" v-if="$route.query.toType !== '3'">保存</el-button>
      <el-button type="importNew" size="small" @click="saveReq(1)">提交申请</el-button>
    </div>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import { bpmnroute } from '@/api/apiRoute';
import store from '@/store';
import Title from '@/components/title/title.vue';
import printDialogCheck from './components/printCost.vue';
import ExcelFile from './components/excelFile.vue'
import Decimal from "decimal"
import DecimalJs from "decimal.js"
export default {
  components: {
    Title,
    printDialogCheck,
    ExcelFile
  },
  data() {
    return {
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      tableLoading: false,
      flowType: '00017',
      fullscreenLoading: false,
      tableData: [],
      isApplyInvoiceTableData: [], //上游数据
      advanceInvoicingTableData: [], //预开票数据
      invoiceGuidTableData: [], //上游票据信息数据
      fileList: [], //运营报告
      fileListOther: [], //附件
      showFile: false,
      pageData: null, //页面所有数据
      planData:null,//推广数据
      // 表单内容
      formData: {
        guid: null,
        isApplyStamp: 'Y', //是否申请盖章，Y 是；N 否
        stampType: null, //类型盖章，1 业务章；2 公章
        isShowPromotionPlan: null, //是否需要推广计划盖章，Y 是；N 否
        isApplyInvoice: null, //是否申请开票，Y 是；N 否
        isInvoiced: null, //是否已开票，Y 是；N 否
        contractBankGuid: null, //	合同开户行唯一标识
        remarks: null, //备注
        bizApproveState: null, //是否重新提交
        isMail: null, //是否邮寄
        mailAddress:null,//邮寄地址
        currentTenantGuid: null, //当前企业id
        isSendFlowFlag: null, //是否发起流程
        planInvoiceApplyGuidList: [], //预开票流程唯一标识
        reportFile: [], //运营报告
        otherFile: [], //其他附件
        invoiceApplyDTO: null, //付款单开票申请修改参数
        tenantBankGuid: null, //企业（服务商）开户行唯一标识
        bankName: null, //银行名称
        bankAccount: null, //银行账号
        contacts: null, //联系人
        invoiceDataSource: null, //票据类型
        invoiceGuids: [], //上游票据信息（多选）
        isDisplayReceipt: ''  // 是否显示验收单
      },
      planInvoiceReceivePaymentList: [
          {
            planInvoiceApplyList: [],
            receivePaymentList: [],
            invoiceGuids:[],
            invoiceDataSource:'1',
          }
        ], //预开票和关联收款信息
      invoiceApplyDTO: {
        guid: null,
        servicerTenantGuid: null, //服务商唯一标识，开票主体
        servicerTenantName: null, //服务商名称
        invoiceAmount: null, //合计任务金额
        serviceFee: null, //平台运营服务费
        currentPayAmount: null, //应付金额
        tenantGuid: null, //企业id
        tenantName: null, //企业名称
        organisationGuid: [], //组织guid
        organisationName: null, //组织名称
        invoiceOptions: null, //发票类型
        invoiceApplyDetailList:[{invoiceCategory:null,invoiceAmount:null}],//发票类目
        planRepayDate: null, //预计回款日期
        remarks: null, //备注
        taxpayerId: null, //税号
        contactTel: null, //电话号码
        contractBankGuid: null, //合同开户行唯一标识
        bankName: null, //银行名称
        bankAccount: null, //银行账号
        invoiceTenantName:null,//发票抬头
        address: null, //地址
        bizApproveState: null,
        isMail: null, //是否邮寄
        isReceivePayment: 'N', //是否回款，Y 是；N 否
        currentTenantGuid: null, //当前登录人的公司唯一标识
        isSendFlowFlag: null,
        paymentTicketGuidList: [], //付款通知单唯一标识
        receivePaymentGuidList: [], //上游收款信息唯一标识
        invoiceDate:null//开票日期
      },
      trueOrFalseOption: [
        { text: '是', value: 'Y' },
        { text: '否', value: 'N' },
      ],
      dataSourceOption: [
        { text: '预开票', value: '1' },
        { text: '上游票据信息', value: '2' },
      ],
      operationDialogVisible: false,
      operationTableData: [],
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: false,
      //开票信息
      tenantList: [], //药企
      serviceTenantList: [], //服务商
      organisationList: [], //组织
      bankList: [],
      currentTenantBankList: [],
      // 打印
      showPrint: false,
      printData: null,
      fileSizeTip: '20',
      currentTenantName: '',
      bizList:[],//业务参数配置的列表
      promotionType:1,//1推广计划确认单 2服务项目预算确认单
      promotionTitle:'推广计划确认单',//1推广计划确认单 2服务项目预算确认单
    };
  },
  watch:{
    "formData.isApplyStamp"(val){
      if(val=='N'){
        this.formData.stampType=null
      }
    },
    "formData.isMail"(val){
      if(val=='N'){
        this.formData.mailAddress=null
      }
    },
  },
  created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.currentTenantName = userInfo.tenantName;
    this.invoiceApplyDTO.servicerTenantGuid = localStorage.guid;
    this.getFlowGuid();
    if (this.$route.query.guid) {
      this.getPageDetail();
      this.getPlanDetail();
    }
  },
  methods: {
    ceilToTwoDecimals(num) {
      const value = new DecimalJs(num)
      // 产品想要的效果是保留两位小数 必须向上进一
      // 比如 6.000000 向上取整应该是 是 6.00, 但是产品需要 6.01
      // 6.000001 向上取整 6.01
      // 6.000009 向上取整是 6.01
      // 6.010000 向上取整是 6.01 产品需要 6.02
      // 如果floorToTwoDecimals大于等于100，不需要加0.01
      
      // 取整后加 0.01
      const floorToTwoDecimals = value.times(100).floor().dividedBy(100)
      if (floorToTwoDecimals.greaterThanOrEqualTo(100)) {
        return floorToTwoDecimals.toFixed(2)
      }
      return floorToTwoDecimals.plus(0.01).toFixed(2)
    },
    getComprehensiveGrade(item) {
      if (!item.comprehensiveGrade) {
        return '-';
      }
      // 保留两位小数 向上取整
      if (item.scoreRule == 1) {
        return this.ceilToTwoDecimals(item.comprehensiveGrade)
      }
      // 原有逻辑 四舍五入
      if (item.scoreRule == 2) {
        return item.comprehensiveGrade.toFixed(2)
      }
    },
    getTypeBizList(guid) {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${guid}&code=PAYMENT_TICKET_PLAN`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let bizList = resp.data.data;
            this.promotionType=1
            this.promotionTitle='推广计划确认单'
            const obj = bizList.find(item => item.tenantGuid === guid);
            if (obj) {
              this.promotionType=2//1推广计划确认单 2服务项目预算确认单
              this.promotionTitle = obj.name;
            }
            this.$forceUpdate();
          } else {
            that.$message.error(resp.data.msg);
          }
        });
    },
    getTitleType(guid){
      let title='付款通知书'
      const obj = this.bizList.find(item => item.tenantGuid === guid);
      if (obj) {
          title = obj.name;
      }
      return title
    },
    getTitleBizList(guid) {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${guid}&code=PAYMENT_TICKET_TITLE`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.bizList = resp.data.data;
            this.$forceUpdate();
          } else {
            that.$message.error(resp.data.msg);
          }
        });
    },
    getSumAmount(list, type) {
      let sum = 0;
      console.log('96',list);
      
      if (type == 1) {
        list.forEach((item) => {
          this.advanceInvoicingTableData.filter(j=>{
            if(item==j.guid){
              console.log('j',j);
              
              sum += Math.round(j.invoiceAccount * 100) / 100 ;
            }
          })
          
        });
      }
      if (type == 2) {
        // isApplyInvoiceTableData
        list.forEach((item) => {
          this.isApplyInvoiceTableData.filter(j=>{
            if(item==j.guid){
              sum += Math.round(j.receiveAmount * 100) / 100 ;
            }
          })
          
        });
      }
      if (type == 3) {
        list.forEach((item) => {
          if(item.invoiceDataSource=='1'&&item.planInvoiceApplyList.length>0){
            item.planInvoiceApplyList.forEach(item2=>{
              this.advanceInvoicingTableData.filter(j=>{
                if(item2==j.guid){
                  sum += Math.round(j.invoiceAccount * 100) / 100 ;
                }
              })
            })
            
            
            
          }
          if(item.invoiceDataSource=='2'){
            // 上游票据信息多选：累加该行所有选中发票的开票金额
            (item.invoiceGuids||[]).forEach(g => {
              this.invoiceGuidTableData.filter(j=>{
                if(g==j.guid){
                  sum += Math.round(j.invoiceAccount * 100) / 100 ;
                }
              })
            })
          }
          
        });
      }
      if (type == 4) {
        // isApplyInvoiceTableData
        list.forEach((item) => {
          if(item.receivePaymentList.length>0){
            item.receivePaymentList.forEach(item2=>{
              this.isApplyInvoiceTableData.filter(j=>{
                if(item2==j.guid){
                  sum += Math.round(j.receiveAmount * 100) / 100 ;
                }
              })
            })
          }
          
          
        });
      }
      if (type == 5) {
        // isApplyInvoiceTableData
        list.forEach((item) => {
          this.isApplyInvoiceTableData.filter(j=>{
            if(item==j.guid){
              sum += Math.round(j.receiveAmount * 100) / 100 ;
            }
          })
          
        });
      }
      if (type == 6) {
        // isApplyInvoiceTableData
        list.forEach((item) => {
          this.advanceInvoicingTableData.filter(j=>{
            if(item==j.guid){
              sum += Math.round(j.invoiceAccount * 100) / 100 ;
            }
          })
          
        });
      }
      if (type == 7) {
        // 上游票据信息多选：list 为 guid 数组，累加所有选中发票的开票金额
        (list||[]).forEach((g) => {
          this.invoiceGuidTableData.filter(j=>{
            if(g==j.guid){
              sum += Math.round(j.invoiceAccount * 100) / 100 ;
            }
          })
        })
      }
      if (type == 8) {
        if(!list||!list.length)return
        list.forEach((item) => {
          sum += Math.round(item.taskAmount * 100) / 100 ;
        });
      }
      return sum;
    },
    //新增预开票关联收款
    addItem() {
      try {
        this.planInvoiceReceivePaymentList.forEach((item,idx) => {
          // console.log('item.bankAccount',item.bankAccount);
          if (item.invoiceDataSource=='1'&&(item.planInvoiceApplyList.length<1 || item.receivePaymentList.length<1)) {
            throw new Error('请完善信息后再新增');
          }
          if (item.invoiceDataSource=='2'&&(!item.invoiceGuids || !item.invoiceGuids.length || item.receivePaymentList.length<1)) {
            throw new Error('请完善信息后再新增');
          }
          
        });
      } catch (e) {
        this.$message.warning(e.message);
        return;
      }
      this.planInvoiceReceivePaymentList.push({
        planInvoiceApplyList: [],
        receivePaymentList: [],
        invoiceGuids: [],
        invoiceDataSource:'1',
      });
    },
    //删除预开票关联收款
    delItem(item,index) {
      var self = this;
      self.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
          this.planInvoiceReceivePaymentList.splice(index, 1);
      });
      
    },
        //新增发票类目
    addInvoiceCategory(){
      this.invoiceApplyDTO.invoiceApplyDetailList.push({
        invoiceCategory:null,
        invoiceAmount:null
      })
    },
     //删除发票类目
    delInvoiceCategory(index){
      this.invoiceApplyDTO.invoiceApplyDetailList.splice(index,1)
    },
    //查看附件
    toSee(item, index) {
      let path = item.path;
      if (path.indexOf('.pdf' || '.PDF') > -1) {
        window.open(path);
      } else {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path));
      }
    },
    seeDetail(item) {
      let self = this;
                   
     console.log('ii',this.pageData);
          this.$router.push({
              path: '/taskDeliverDetail?guid=' + item.guid,
              query: {
                  flag:1,
              }
          })
                
       
        },
    //获取预开票数据
    getAdvanceInvoiceList(type) {
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        pageIndex: 1,
        pageSize: -1,
        approveState: 'Y',
        flowType: '00019',
        isUsed: null,
        searchKey: null,
        staffGuid: userinfo.staffGuid,
        tenantGuid: this.pageData.tenantGuid,
        currentServiceTenantGuid: localStorage.guid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/upstream/payment-plan-invoice-apply/get-select-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.advanceInvoicingTableData = res.data.data || [];
            if (self.advanceInvoicingTableData.length > 0) {
              self.advanceInvoicingTableData.forEach((i) => {
                i.label =
                  self.$moment(i.invoiceDate).format('YYYY-MM-DD') +
                  ' — ' +
                  this.formatMoney(i.invoiceAccount || 0) +
                  '元';
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取上游票据信息数据
    getinvoiceGuidList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        invoiceTenantGuid:this.pageData.serviceTenantGuid,
        receiveTenantGuid: this.pageData.tenantGuid,
        // 排除已对冲(H)票，只选未回款(N)和已回款(Y)的发票
        paymentCollectionStatusList: ['N', 'Y'],
      };
      self.api
        .postJson(`/${serverConfig.msCustomerService}/upstream-invoice-info/get-invoice-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.invoiceGuidTableData = res.data.data || [];
            if (self.invoiceGuidTableData.length > 0) {
              self.invoiceGuidTableData.forEach((i) => {
                i.label =
                  self.$moment(i.invoiceDate).format('YYYY-MM-DD') +
                  ' — ' +
                  this.formatMoney(i.invoiceAccount || 0) +
                  '元';
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取当前企业银行数据
    getCurrentBank() {
      let self = this;
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=${localStorage.guid}`)
        .then((res) => {
          let { code, data, msg } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.currentTenantBankList = data.bankList;
            self.formData.contacts = data.contacts;
            self.pageData.contacts = data.contacts;
            // self.currentTenantBankList.forEach(item => {
            //   item.bankNameLabel = item.bankName + ' _ ' + item.bankAccount + ' _ ' + this.getName(item.accountType, '账户类型');
            // })
            console.log(self.currentTenantBankList)
          } else {
            self.$message.error(msg);
          }
        });
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach(item => {
          list.forEach(el => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          })
        })
        return newArr.length ? newArr.join('、') : '-';

      } else {
        let lisArr = list.filter(item => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }
    },
    //获取推广计划
    getPlanDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/payment-ticket/get-task-detail?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.planData = res.data.data;
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 任务描述
    getTenantTaskNote(detail) {
      if (detail.taskTotalType == '固定量人均') {
        var total = detail.taskTotal;
        return detail.tenantTaskNote.replace('#总任务量#', total);
      } else if (detail.taskTotalType == '系统计算') {
        var total = detail.taskTotal;
        return detail.tenantTaskNote.replace('#总任务量#', total);
      }
    },
    //获取银行信息
    tenantBankChange(val) {
      if (val) {
        this.currentTenantBankList.forEach((i) => {
          if (val == i.guid) {
            this.formData.bankAccount = i.bankAccount;
            this.formData.bankName = i.bankName;
            this.pageData.bankAccount = i.bankAccount;
            this.pageData.bankName = i.bankName;
          }
        });
      }
    },
    //获取运营报告数据
    getOperationList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        flowType: '00016',
        bizGuids: this.pageData.operationReportGuidList,
        isHedgeList:["Y","N"]
        // currentServiceTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.operationTableData = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    /************************************开票信息开始************************************** */
    //获取服务商
    getServiceTenantList() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-service-tenants`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data || [];
          self.servicerTenantChange(self.invoiceApplyDTO.servicerTenantGuid);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //服务商发生变化时赋值并清空企业名称
    servicerTenantChange(val) {
      if (val) {
        this.serviceTenantList.forEach((i) => {
          if (i.sendTenantGuid == val) {
            this.invoiceApplyDTO.servicerTenantName = i.tenantName;
          }
        });
        // this.invoiceApplyDTO.tenantName = null;
        // this.invoiceApplyDTO.tenantGuid = null;
        this.getTenantList(val);
        this.getOrganisationList(this.pageData.tenantGuid);
      }
    },
    //获取上游数据
    getInvoiceItem(val) {
      let self = this;
      let query = {
        streamType: '1',
        payTenantGuid: self.invoiceApplyDTO.tenantGuid,
        receiveTenantGuid: localStorage.guid,
        isQueryChild:"Y"
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/get-select-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.isApplyInvoiceTableData = res.data.data || [];
          if (self.isApplyInvoiceTableData.length > 0) {
            self.isApplyInvoiceTableData.forEach((i) => {
              i.label =
                self.$moment(i.receiveDate).format('YYYY-MM-DD') +
                '收款 ' +
                (this.formatMoney(i.receiveAmount) || 0) +
                ' 元';
            });
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取药企
    getTenantList(val) {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
            //药企名称默认赋值
            self.invoiceApplyDTO.tenantGuid = self.pageData.tenantGuid;
            self.getBankList(self.pageData.tenantGuid);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //药企名称改变清空其余值
    tenantChange(val) {
      if (val) {
        this.tenantList.forEach((i) => {
          if (i.sendTenantGuid == val) {
            this.invoiceApplyDTO.tenantName = i.sendTenantName;
          }
        });
        this.getOrganisationList(val);
        this.getBankList(val);
        this.invoiceApplyDTO.organisationName = null;
        this.invoiceApplyDTO.organisationGuid = [];
        this.invoiceApplyDTO.bankName = null;
        this.invoiceApplyDTO.contractBankGuid = null;
        this.invoiceApplyDTO.bankAccount = null;
        this.invoiceApplyDTO.taxpayerId = null;
        this.invoiceApplyDTO.address = null;
        this.invoiceApplyDTO.contactTel = null;
      }
    },
    //企业选择验证
    tenantFocus(type) {
      if (!this.invoiceApplyDTO.servicerTenantGuid) {
        this.$message.error('请先选择开票主体');
      }
      if (type == 2 && !this.invoiceApplyDTO.tenantGuid) {
        this.$message.error('请先选择药企');
      }
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/get-organisation-dict?tenantGuid=${v}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    organisationChange(val) {
      if (val) {
        this.organisationList.forEach((i) => {
          if (i.value == val) {
            this.invoiceApplyDTO.organisationName = i.text;
          }
        });
      }
    },
    //获取开户银行
    getBankList(val) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/get-tenant-invoice-list?tenantGuid=${val}&bizState=Y`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.bankList = res.data.data || [];
            // self.bankList.forEach(item => {
            //   item.bankNameLabel = item.bankName + ' _ ' + item.bankAccount + ' _ ' + this.getName(item.accountType, '账户类型');
            // })
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 银行值变化时赋值
    bankChange(val) {
      if (val) {
        this.bankList.forEach((i) => {
          if (i.guid == val) {
            this.invoiceApplyDTO.bankName = i.bankName;
            this.invoiceApplyDTO.bankAccount = i.bankAccount;
            this.invoiceApplyDTO.taxpayerId = i.taxpayerId;
            this.invoiceApplyDTO.address = i.address;
            this.invoiceApplyDTO.contactTel = i.tel;
            this.invoiceApplyDTO.invoiceTenantName = i.tenantName;
          }
        });
      }
    },
    isApplyInvoiceChange(val) {
      this.invoiceApplyDTO.invoiceAmount = val == 'Y' ? this.formData.currentPayAmount.toFixed(2) : null;
      if (val == 'Y') {
        this.invoiceApplyDTO.invoiceDate = null;
        this.invoiceApplyDTO.tenantName = this.pageData.tenantName;
        this.invoiceApplyDTO.organisationGuid = this.pageData.organisationGuid;
        this.invoiceApplyDTO.organisationName = this.pageData.organisationName;
      }
    },
    /************************************开票信息结束************************************** */
    //运营报告详情
    toOperationDetail(row){
      let query = {
        guid: row.guid,
        approveStaffGuid: row.approveGuid,
        camundaInstanceId: row.camundaInstanceId,
        camundaDeploymentId: row.camundaDeploymentId,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: row.staffGuid,
        submitStaffName: row.staffName,
        toType:2,
        productGuid:this.$route.query.productGuid
      };
      this.$router.push({
        path: '/upstreamOperationReportDetail',
        query,
      });
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/payment-ticket/detail?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            self.pageData = data;
            self.getTypeBizList(self.pageData.tenantGuid)
            self.getTitleBizList(self.pageData.tenantGuid)
            //获取服务商信息
            self.getServiceTenantList();
            self.getAdvanceInvoiceList(1);
            self.getinvoiceGuidList();
            self.getCurrentBank();
            self.getFormData(2, data);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //页面信息
    getFormData(type, data) {
      let self=this
      this.tableData = data.detailList;
      this.formData = {
        guid: type == 1 ? null : data.guid,
        isApplyStamp: data.isApplyStamp,
        isShowPromotionPlan: data.isShowPromotionPlan,
        isApplyInvoice: data.isApplyInvoice,
        isInvoiced: data.isInvoiced,
        stampType:data.stampType,
        contractBankGuid: data.contractBankGuid,
        remarks: data.remarks,
        bizApproveState: data.bizApproveState,
        isMail: data.isMail,
        mailAddress:data.mailAddress,
        currentTenantGuid: data.currentTenantGuid,
        isSendFlowFlag: data.isSendFlowFlag,
        planInvoiceApplyGuidList: data.planInvoiceApplyGuidList,
        reportFile: data.reportFile,
        otherFile: data.otherFile,
        invoiceApplyDTO: null,
        tenantBankGuid: data.tenantBankGuid,
        bankName: data.bankName,
        bankAccount: data.bankAccount,
        contacts: data.contacts,
        currentPayAmount: data.currentPayAmount,
        invoiceDataSource: data.invoiceDataSource, //票据类型
        invoiceGuids: data.invoiceGuidList || [], //上游票据信息（多选）
        isDisplayReceipt: data.isDisplayReceipt
      };
      if(data.isInvoiced=='Y'&&data.isReceivePayment=='Y'){
        let obj={
          planInvoiceApplyList:[],
          receivePaymentList:[],
          invoiceGuids:[],
          invoiceDataSource:null
        }
        if(data.planInvoiceReceivePaymentList.length>0){
          data.planInvoiceReceivePaymentList.forEach((item,idx)=>{
            self.planInvoiceReceivePaymentList[idx]=JSON.parse(JSON.stringify(obj));
            if(item.invoiceDataSource=='1'){
              item.planInvoiceApplyList.forEach(list1 => {
                self.planInvoiceReceivePaymentList[idx].planInvoiceApplyList.push(list1.guid)
              })
            }
            if(item.invoiceDataSource=='2'){
              // 后端已降级填充 invoiceInfoList，统一从它回填多选数组
              let infoList = item.invoiceInfoList || [];
              if(!infoList.length && item.invoiceInfo){ infoList = [item.invoiceInfo]; }
              self.planInvoiceReceivePaymentList[idx].invoiceGuids = infoList.map(x => x.guid);
            }
           
            item.receivePaymentList.forEach(list2 => {
              
              self.planInvoiceReceivePaymentList[idx].receivePaymentList.push(list2.guid)
            })
            
            self.planInvoiceReceivePaymentList[idx].invoiceDataSource=item.invoiceDataSource
          })
        }else{
          self.planInvoiceReceivePaymentList =[{
          planInvoiceApplyList:[],
          receivePaymentList:[],
          invoiceGuids:[],
          invoiceDataSource:'1'
        }];
        }
      }
      
      
      if (data.invoiceApplyVO) {
        this.invoiceApplyDTO = data.invoiceApplyVO;
        this.invoiceApplyDTO.paymentTicketGuidList = this.invoiceApplyDTO.paymentTicketGuidList || [];
        this.invoiceApplyDTO.receivePaymentGuidList = this.invoiceApplyDTO.receivePaymentGuidList || [];
        // this.invoiceApplyDTO.isReceivePayment = data.isReceivePayment;
        // this.invoiceApplyDTO.receivePaymentGuidList = data.receivePaymentGuidList || [];
        // this.invoiceApplyDTO.invoiceAmount = data.currentPayAmount.toFixed(2);
        this.invoiceApplyDTO.invoiceApplyDetailList = this.invoiceApplyDTO.invoiceApplyDetailList||[{invoiceCategory:null,invoiceAmount:null}],
        this.getOrganisationList(this.invoiceApplyDTO.tenantGuid);
        this.getBankList(this.invoiceApplyDTO.tenantGuid);
        // this.getInvoiceItem();
      }
      this.invoiceApplyDTO.isReceivePayment = data.isReceivePayment||'N';
      this.invoiceApplyDTO.receivePaymentGuidList = data.receivePaymentGuidList || [];
      this.invoiceApplyDTO.invoiceAmount = data.currentPayAmount.toFixed(2);
      console.log('getformdata',this.invoiceApplyDTO);
      
      this.getInvoiceItem();
      this.getOperationList();
      // 运营报告格式处理
      if (this.formData.reportFile && this.formData.reportFile.length < 2) {
        this.showFile = true;
        this.formData.reportFile.forEach((i) => {
          if (i.path.indexOf('.pdf' || '.PDF') > -1) {
            i.type = 'pdf';
          } else if (i.path.indexOf('.xls' || '.xlsx') > -1) {
            i.type = 'excel_icon';
          } else {
            i.type = 'word';
          }
          let obj = {
            name: i.fileName,
            path: i.path,
            type: i.type,
          };
          this.fileList.push(obj);
        });
      } else {
        this.showFile = false;
        if (this.formData.reportFile && this.formData.reportFile.length > 0) {
          this.formData.reportFile.forEach((i) => {
            let obj = {
              name: i.fileName,
              path: i.path,
            };
            this.fileList.push(obj);
          });
        }
      }
      //其他附件格式处理
      if (this.formData.otherFile && this.formData.otherFile.length > 0) {
        this.formData.otherFile.forEach((i) => {
          let obj = {
            name: i.fileName,
            path: i.path,
          };
          this.fileListOther.push(obj);
        });
      }
    },
    // 页面校验
    checkPageForm() {
      if (!this.fileList.length) {
        this.$message.error('运营报告不能为空');
        return false;
      }
      if (!this.formData.isApplyStamp) {
        this.$message.error('申请盖章不能为空');
        return false;
      }
      if (this.formData.isApplyStamp=='Y'&&!this.formData.stampType) {
        this.$message.error('印章类型不能为空');
        return false;
      }
      if (!this.formData.isShowPromotionPlan) {
        this.$message.error('是否需要推广计划盖章不能为空');
        return false;
      }
      if (!this.formData.isDisplayReceipt) {
        this.$message.error('是否需要验收单盖章不能为空');
        return false;
      }
      if (!this.formData.isMail) {
        this.$message.error('是否邮寄不能为空');
        return false;
      }
      if (!this.formData.isApplyInvoice) {
        this.$message.error('申请开票不能为空');
        return false;
      }
      if (!this.formData.isInvoiced) {
        this.$message.error('是否已开票不能为空');
        return false;
      }
      if (this.formData.isInvoiced == 'Y' &&this.invoiceApplyDTO.isReceivePayment=='N' && this.formData.invoiceDataSource =='1' && !this.formData.planInvoiceApplyGuidList.length) {
        this.$message.error('预开票流程不能为空');
        return false;
      }
      if (this.formData.isInvoiced == 'Y' &&this.invoiceApplyDTO.isReceivePayment=='N' && this.formData.invoiceDataSource =='2' && !this.formData.invoiceGuids.length) {
        this.$message.error('上游票据信息不能为空');
        return false;
      }
      if (!this.invoiceApplyDTO.isReceivePayment) {
        this.$message.error('是否回款不能为空');
        return false;
      }
      if (this.formData.isInvoiced == 'N' && this.invoiceApplyDTO.isReceivePayment=='Y'&&!this.invoiceApplyDTO.receivePaymentGuidList.length) {
        this.$message.error('关联上游收款不能为空');
        return false;
      }
      // if (this.formData.isInvoiced == 'Y' && this.invoiceApplyDTO.isReceivePayment=='Y') {
      //   // &&this.planInvoiceReceivePaymentList.length<1
      //   this.$message.error('预开票流程和关联上游收款不能为空');
      //   return false;
      // }
      console.log('this.formData',this.planInvoiceReceivePaymentList);
      
      try {
        if(this.formData.isInvoiced == 'Y' && this.invoiceApplyDTO.isReceivePayment=='Y'){
          this.planInvoiceReceivePaymentList.forEach((item,idx) => {
          console.log('item',item);
          
          if (item.invoiceDataSource=='1' && (item.planInvoiceApplyList.length<1 || item.receivePaymentList.length<1)) {
            throw new Error('预开票流程或关联上游收款不能为空');
          }
          if (item.invoiceDataSource=='2' && (!item.invoiceGuids || !item.invoiceGuids.length || item.receivePaymentList.length<1)) {
            throw new Error('上游票据信息或关联上游收款不能为空');
          }
          
        });
        }
        
      } catch (e) {
        this.$message.error(e.message);
        return false;
      }
      // if (!this.formData.remarks) {
      //   this.$message.error('备注说明不能为空');
      //   return false;
      // }
      return true;
    },
    //开票申请校验
    checkApplyForm() {

   
      if (!this.invoiceApplyDTO.servicerTenantGuid) {
        this.$message.error('开票主体不能为空');
        return false;
      }
      if (!this.invoiceApplyDTO.invoiceDate) {
        this.$message.error('开票日期不能为空');
        return false;
      }
      if (!this.invoiceApplyDTO.invoiceOptions) {
        this.$message.error('发票类型不能为空');
        return false;
      }
      if (!this.invoiceApplyDTO.tenantGuid) {
        this.$message.error('药企名称不能为空');
        return false;
      }
      if (!this.invoiceApplyDTO.organisationGuid) {
        this.$message.error('组织名称不能为空');
        return false;
      }
      // if (!this.invoiceApplyDTO.month) {
      //   this.$message.error('月份不能为空');
      //   return false;
      // }
      // if (!this.invoiceApplyDTO.invoiceCategory) {
      //   this.$message.error('发票类目不能为空');
      //   return false;
      // }
      if (!this.invoiceApplyDTO.planRepayDate) {
        this.$message.error('预计回款日期不能为空');
        return false;
      }
   
      // if (!this.invoiceApplyDTO.remarks) {
      //   this.$message.error('简述或备注不能为空');
      //   return false;
      // }
      if (!this.invoiceApplyDTO.invoiceTenantName) {
        this.$message.error('发票抬头不能为空');
        return false;
      }
      try {
        this.invoiceApplyDTO.invoiceApplyDetailList.forEach((item, index) => {
          if (!item.invoiceCategory) {
            throw new Error(`发票类目${index + 1}不能为空`)
          }
          if (!item.invoiceAmount) {
            throw new Error('金额不能为空')
          }
        })
      } catch (error) {
        this.$message.error(error.message);
        return false
      }
      let invoiceAmount = 0;
      this.invoiceApplyDTO.invoiceApplyDetailList.forEach(item => {
         invoiceAmount = Decimal(invoiceAmount).add(item.invoiceAmount);
      })
      let amount=+this.invoiceApplyDTO.invoiceAmount
      if (invoiceAmount != amount) {
        this.$message.error('发票类目金额之和必须与开票金额相等');
        return false;
      }
      if (!this.invoiceApplyDTO.bankName) {
        this.$message.error('开户银行不能为空');
        return false;
      }
      return true;
    },
    filterPlanInvoice(guid,flg){
      let list=flg==1?this.advanceInvoicingTableData:this.invoiceGuidTableData
      console.log('filterPlanInvoice',flg,list.filter(item => item.guid == guid)[0],guid);
      
      return list.filter(item => item.guid == guid)[0]
    },
    filterReceivePayment(guid){
      return this.isApplyInvoiceTableData.filter(item => item.guid == guid)[0]
    },
    //提交申请 type为1时提交，0保存
    saveReq(type) {
      if (type == 1 && !this.checkPageForm()) {
        return;
      }
      if (type == 1 && this.formData.isApplyInvoice == 'Y' && !this.checkApplyForm()) {
        return;
      }
      if (type == 1 && !this.formData.tenantBankGuid) {
        this.$message.error('支付账户开户银行不能为空');
        return;
      }
      // let userinfo = JSON.parse(localStorage.userInfo);
      let form = this.formData;
      
      if(this.formData.isInvoiced == 'Y' && this.invoiceApplyDTO.isReceivePayment=='Y'){
        form.invoiceDataSource=""
        // 如果都为是，传这个数组
        form.planInvoiceReceivePaymentList=[]
        let obj={
            planInvoiceApplyList: [],
            receivePaymentList: [],
            invoiceInfo:null,
            invoiceInfoList:[],
            invoiceDataSource:null
          }
        console.log('000', this.planInvoiceReceivePaymentList);
        
       this.planInvoiceReceivePaymentList.forEach((item,idx) => {
        form.planInvoiceReceivePaymentList[idx]=JSON.parse(JSON.stringify(obj))
        form.planInvoiceReceivePaymentList[idx].planInvoiceApplyList=[]
        form.planInvoiceReceivePaymentList[idx].receivePaymentList=[]
        if(item.invoiceDataSource=='1'){
          item.planInvoiceApplyList.forEach(guid1 => {
          let obj1={
            guid: guid1,
            desc: this.filterPlanInvoice(guid1,1).invoiceAccount,
            name:this.filterPlanInvoice(guid1,1).label
          }
          form.planInvoiceReceivePaymentList[idx].planInvoiceApplyList.push(obj1)
        })
        }
        
        item.receivePaymentList.forEach(guid2 => {
          let obj2={
            guid: guid2,
            desc:this.filterReceivePayment(guid2).receiveAmount,
            name:this.filterReceivePayment(guid2).label
          }
          form.planInvoiceReceivePaymentList[idx].receivePaymentList.push(obj2)
        })
        if(item.invoiceDataSource=='2'){
          // 多选：把选中的发票 guid 数组组装成 invoiceInfoList
          form.planInvoiceReceivePaymentList[idx].invoiceInfoList = (item.invoiceGuids||[]).map(g => {
            let info = this.filterPlanInvoice(g,2) || {};
            return { guid: g, desc: info.invoiceAccount, name: info.label };
          });
        }
        
        form.planInvoiceReceivePaymentList[idx].invoiceDataSource=item.invoiceDataSource
        
        
       })
      }
      console.log('form.',form.planInvoiceReceivePaymentList);
      
      let reqUrl;
      // form.staffGuid = userinfo.staffGuid;
      // form.staffName = userinfo.staffName;
      // form.currentTenantGuid = userinfo.tenantGuid;
      form.isSendFlowFlag = type == 1 ? 'Y' : 'N';
      //重新提交
      if (this.$route.query.toType == '3') {
        form.bizApproveState = 'D';
      }
      if (this.formData.isApplyInvoice == 'Y') {
        this.formData.invoiceApplyDTO = this.invoiceApplyDTO;
      } else {
        this.formData.invoiceApplyDTO = null;
      }
       //关联上下游放在最外层
      if (this.invoiceApplyDTO.receivePaymentGuidList && this.invoiceApplyDTO.receivePaymentGuidList.length > 0) {
        this.formData.receivePaymentGuidList = this.invoiceApplyDTO.receivePaymentGuidList;
      } else {
        this.formData.receivePaymentGuidList = [];
      }
      //是否回款放在最外层
      if (this.invoiceApplyDTO.isReceivePayment) {
        this.formData.isReceivePayment = this.invoiceApplyDTO.isReceivePayment;
      }
      //判断运营报告附件是否存在
      if (this.fileList.length > 0) {
        this.formData.reportFile = [];
        this.fileList.forEach((i) => {
          let obj = {
            fileName: i.name,
            path: i.path,
          };
          this.formData.reportFile.push(obj);
        });
      }else{
        this.formData.reportFile = [];
      }
      //判断其他附件是否存在
      if (this.fileListOther.length > 0) {
        this.formData.otherFile = [];
        this.fileListOther.forEach((i) => {
          let obj = {
            fileName: i.name,
            path: i.path,
          };
          this.formData.otherFile.push(obj);
        });
      }else{
        this.formData.otherFile = [];
      }
      reqUrl = `/upstream/payment-ticket/update`;
      this.fullscreenLoading = true;
      form.currentTenantGuid = localStorage.guid;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}${reqUrl}`, form)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '提交成功',
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //获取流程Guid
    getFlowGuid() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.srcs =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              console.log(self.srcs);
            } else {
              self.$message.error('未获取到流程信息');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    /************************导入***********************************/
    handleExceed(files) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleFileRemove(file) {
      let self = this;
      self.fileList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileList.splice(ind, 1);
        }
      });
    },
    //上传限制
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: 'warning',
        });
      }
      return isLt2M;
    },
    uploadFile(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data,
            };
            self.fileList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleExceedOther(files) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleFileRemoveOther(file) {
      let self = this;
      self.fileListOther.forEach(function (j, ind) {
        if (j.path == file.path) {
          self.fileListOther.splice(ind, 1);
        }
      });
    },
    //上传限制
    beforeAvatarUploadOther(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: 'warning',
        });
      }
      return isLt2M;
    },
    uploadFileOther(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data,
            };
            self.fileListOther.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    // 是否已开票
    isInvoicedChange(val) {
      //  if(formData.isInvoiced == 'N'){
      console.log('vvv',val);
      this.formData.invoiceDataSource=val=='Y'?'1':null
      this.formData.isApplyInvoice = 'N';
      this.formData.planInvoiceApplyGuidList = [];
      this.formData.invoiceGuids = [];
      this.planInvoiceReceivePaymentList = [
          {
            planInvoiceApplyList: [],
            receivePaymentList: [],
            invoiceGuids:[],
            invoiceDataSource:'1'
          }
        ]; //预开票和关联收款信息
      //  }
      
      
      // this.formData.isInvoicedChange='1'
    },
    isDataSourceChange(val,item) {
      console.log('vvv',val,item);
      if(item){
        item.planInvoiceApplyList=[]
        item.invoiceGuids=[]
      }else{
        this.formData.planInvoiceApplyGuidList = [];
        this.formData.invoiceGuids = [];
        this.planInvoiceReceivePaymentList = [
          {
            planInvoiceApplyList: [],
            receivePaymentList: [],
            invoiceGuids:[],
            invoiceDataSource:'1'
          }
        ]; 
      }
      
      this.$forceUpdate()
    },
    isReceivePaymentChange(val) {
      this.formData.planInvoiceApplyGuidList = [];
      this.formData.invoiceGuids = [];
      if(val=='N'){
        this.formData.invoiceDataSource='1'
      }else{
        this.formData.invoiceDataSource=null
      }
      this.invoiceApplyDTO.receivePaymentGuidList = [];
      this.planInvoiceReceivePaymentList = [
          {
            planInvoiceApplyList: [],
            receivePaymentList: [],
            invoiceGuids:[],
            invoiceDataSource:'1'
          }
        ]; //预开票和关联收款信息
      this.getInvoiceItem();
      
      
    },
  },
  computed: {
    /**工业考核得分 */
    comprehensiveGradeComputed() {
      if (!this.pageData.comprehensiveGrade) {
        return;
      }
      // scoreRule 在operationTableData中 不管多少条数据 都是一样的值 所以直接取第一条
      const scoreRule = this.operationTableData[0]?.scoreRule
      let comprehensiveGrade = Number(this.pageData?.comprehensiveGrade * 100 || 0);
      // 保留两位小数 向上取整
      if (scoreRule == 1) {
        return this.ceilToTwoDecimals(comprehensiveGrade)
      }
      // 原有逻辑 四舍五入
      if (scoreRule == 2) {
        return comprehensiveGrade.toFixed(2)
      }
    },
  },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 0 0 10px 0;
}
.add-button{
  align-items: center;
  color: #4fa1a4;
}
.contract-base-box .el-col-12,
.contract-base-box .el-col-24,
.contract-base-box .el-col-20,
.contract-base-box .el-col-7,
.contract-base-box .el-col-10,
.contract-base-box .el-col-4,
.contract-base-box .el-col-6 {
  min-height: 37px;
  display: flex;
  /* align-items: center; */
  margin-bottom: 8px;
  padding-right: 20px;
  box-sizing: border-box;
}
.sum-row .el-col-10{
  align-items: center !important;
}
/* .contract-base-box .el-col-12{
  width: 550px;
} */
.contract-base-title {
  flex-shrink: 0;
  width: 165px;
  line-height: 36px;
  text-align: right;
  font-size: 14px;
}
.contract-base-content {
  width: 314px;
  text-align: left;
  line-height: 36px;
}
.contract-base-content-left {
  width: 130px;
  text-align: left;
  line-height: 36px;
}
/deep/.el-radio-group {
  padding-top: 5px !important;
}
/* 信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 25px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  height: 40px;
  line-height: 40px;
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 16px;
  box-sizing: border-box;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
table {
  /* border-color: #D9D9D9; */
  font-size: 12px;
  border-spacing: 0px;
  line-height: 30px;
  width: 100%;
  color: #212121;
  border: 1px solid #d9d9d9;
  border-top: none;
  border-left: none;
  text-align: left;
}
table tr td,
.tdBg {
  height: 32px;
  border: 1px solid #d9d9d9;
  border-bottom: none;
  border-right: none;
  padding: 0 6px;
}
.tBg {
  background: #e5e5e5;
}
.tdBg {
  background: #fafafa;
}
.tdCenter {
  text-align: center;
  border-right: none;
}
.pay-box h2 {
  font-size: 20px;
}
.pay-box p {
  text-align: left;
  color: #666666;
}
.pay-title-txt {
  display: flex;
  color: #666666;
  font-size: 14px;
}
.pay-title-txt span:first-child {
  margin-right: 150px;
}
.pay-write {
  text-align: right;
  padding: 90px 60px;
  box-sizing: border-box;
}
.look-detail {
  color: #4fa1a4;
  cursor: pointer;
}
.contract-apply-item span {
  color: #666666;
}
.input-box {
  padding-top: 20px;
  /* border-top: 1px solid #e5e5e5; */
}
.table-total-money{
  font-size:12px;
  border-top:none;
}
.page-write {
  text-align: left;
  display: flex;
  width: 100%;
  border: 1px solid #d9d9d9;
  /* padding: 90px 60px;
  box-sizing: border-box; */
  
}
.page-write div{
  flex: 1;
  padding:5px 60px  60px 5px;

}
.page-write div:first-child{
  border-right:1px solid #d9d9d9;
}
.invoice-category-btns{
  display: flex;
  align-items: center;
  color: #4fa1a4;
  cursor: pointer;
}
.invoice-category-btns .add{
  margin: 0 10px;
}
</style>
